<template>
    <ModalCustom
        :is-open="true"
        @close="$emit('close')"
        title="Select Plays"
        z-index="1001"
    >
        <div class="w-[80vw] max-h-[70vh] overflow-y-auto p-4">
            <div class="flex flex-wrap gap-2 mb-4">
                <div
                    v-for="selectedPlay in selectedPlays"
                    :key="selectedPlay.play_id"
                    class="
                        flex
                        items-center
                        rounded-md
                        px-2
                        py-1
                        text-sm
                        font-medium
                        ring-1 ring-inset ring-blue-700/10
                        text-blue-700
                        bg-blue-50
                        gap-1
                    "
                >
                    <span>{{ selectedPlay.play_name }}</span>
                    <ion-icon
                        name="close-outline"
                        class="cursor-pointer"
                        @click="toggleSelect(selectedPlay)"
                    ></ion-icon>
                </div>
            </div>

            <div v-if="isLoading" class="flex justify-center p-12">
                <loading-circle />
            </div>

            <div v-else class="flex gap-4">
                <div class="w-1/4 bg-gray-50 p-4 rounded-md">
                    <h4 class="font-bold mb-2">Playbooks</h4>
                    <ul class="space-y-1">
                        <li v-for="pb in playbooks" :key="pb.playbook_id">
                            <button
                                @click="activePlaybook = pb"
                                class="
                                    w-full
                                    text-left
                                    px-3
                                    py-2
                                    rounded
                                    text-sm
                                "
                                :class="
                                    activePlaybook?.playbook_id ===
                                    pb.playbook_id
                                        ? 'bg-primary text-white'
                                        : 'hover:bg-gray-200'
                                "
                            >
                                {{ pb.playbook_title }}
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="w-3/4">
                    <div
                        v-if="activePlaybook"
                        class="grid grid-cols-2 md:grid-cols-3 gap-4"
                    >
                        <div
                            v-for="play in activePlaybook.plays"
                            :key="play.play_id"
                            @click="toggleSelect(play)"
                            class="
                                border-2
                                rounded-lg
                                p-2
                                cursor-pointer
                                hover:border-primary
                                transition-colors
                            "
                            :class="
                                isSelected(play)
                                    ? 'border-primary bg-blue-50'
                                    : 'border-gray-200'
                            "
                        >
                            <img
                                :src="
                                    play.thumbnail_url ||
                                    '/default-images/dummy-play.png'
                                "
                                class="
                                    w-full
                                    h-32
                                    object-contain
                                    bg-white
                                    rounded
                                    mb-2
                                "
                            />
                            <div class="text-xs font-bold text-center truncate">
                                {{ play.play_name }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center p-12 text-gray-500">
                        Select a playbook to see plays
                    </div>
                </div>
            </div>

            <div class="mt-6 flex justify-end gap-2 border-t pt-4">
                <button
                    @click="$emit('close')"
                    class="
                        px-4
                        py-2
                        text-sm
                        font-medium
                        text-gray-700
                        hover:bg-gray-100
                        rounded-md
                    "
                >
                    Cancel
                </button>
                <button
                    @click="confirm"
                    class="
                        px-4
                        py-2
                        text-sm
                        font-medium
                        text-white
                        bg-primary
                        hover:bg-primary-dark
                        rounded-md
                    "
                >
                    Confirm Selection
                </button>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import ModalCustom from "../ModalCustom.vue";
import LoadingCircle from "../LoadingCircle.vue";

const props = defineProps({
    playbookApi: String,
    initialSelected: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(["close", "selected"]);

const isLoading = ref(true);
const playbooks = ref([]);
const activePlaybook = ref(null);
const selectedPlays = ref([...props.initialSelected]);

const isSelected = (play) => {
    return selectedPlays.value.some((p) => p.play_id === play.play_id);
};

const toggleSelect = (play) => {
    if (isSelected(play)) {
        selectedPlays.value = selectedPlays.value.filter(
            (p) => p.play_id !== play.play_id
        );
    } else {
        selectedPlays.value.push(play);
    }
};

const confirm = () => {
    emit("selected", [...selectedPlays.value]);
    emit("close");
};

onMounted(async () => {
    const teamId = new URLSearchParams(window.location.search).get("teamId");
    try {
        const response = await axios.get(props.playbookApi, {
            params: { teamId },
        });
        playbooks.value = response.data;
        if (playbooks.value.length > 0) {
            activePlaybook.value = playbooks.value[0];
        }
    } catch (error) {
        console.error("Failed to load playbooks", error);
    } finally {
        isLoading.value = false;
    }
});
</script>
